'use client';

import { Globe } from 'lucide-react';
import { NZ_REGIONS } from '@sizzlenz/shared';
import {
  MultiSelectDropdown,
  MultiSelectOption,
  MultiSelectGroup,
} from '@/components/ui/multi-select-dropdown';

interface RegionSelectorProps {
  selectedRegion?: string | null;
  selectedRegions?: string[];
  onRegionChange?: (regionId: string | null) => void;
  onRegionsChange?: (regionIds: string[]) => void;
  placeholder?: string;
  showIcon?: boolean;
  multiple?: boolean;
  label?: string | null;
  showChips?: boolean;
  showSummaryInTrigger?: boolean;
  maxSummaryLength?: number;
  showBulkActions?: boolean;
}

export function RegionSelector({
  selectedRegion,
  selectedRegions = [],
  onRegionChange,
  onRegionsChange,
  placeholder = 'All Regions',
  showIcon = true,
  multiple = false,
  label = 'Regions',
  showChips = true,
  showSummaryInTrigger = false,
  maxSummaryLength = 40,
  showBulkActions = true,
}: RegionSelectorProps) {
  // Convert NZ regions to MultiSelectOption format
  const regionOptions: MultiSelectOption[] = NZ_REGIONS.map((region) => ({
    id: region.id,
    label: region.name,
  }));

  // Handle selection changes
  const handleSelectionChange = (selectedIds: string[]) => {
    if (multiple && onRegionsChange) {
      onRegionsChange(selectedIds);
    } else if (!multiple && onRegionChange) {
      // For single selection, take the first selected item or null if none
      const newSelection = selectedIds.length > 0 ? selectedIds[0] : null;
      onRegionChange(newSelection);
    }
  };

  // Get current selected IDs for the MultiSelectDropdown
  const currentSelectedIds = multiple ? selectedRegions : selectedRegion ? [selectedRegion] : [];

  return (
    <div className="space-y-2">
      <MultiSelectDropdown
        showSearch
        label={label}
        placeholder={placeholder}
        options={regionOptions}
        selectedIds={currentSelectedIds}
        onSelectionChange={handleSelectionChange}
        showChips={showChips}
        showSummaryInTrigger={showSummaryInTrigger}
        maxSummaryLength={maxSummaryLength}
        showBulkActions={showBulkActions}
      />
    </div>
  );
}
